import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ProductCostHistory } from './product-cost-history.model';

/** The entity name the grid queries, and the crud list route behind it. */
export const COST_HISTORY_ENTITY = 'product-cost-history';

@Injectable({
  providedIn: 'root'
})
export class ProductCostHistoryService {

  private _endpoint: string = environment.api.endpoint;

  constructor(private httpClient: HttpClient) { }

  /**
   * Asks the list route for a single row purely to find out whether it answers.
   *
   * Worth a request of its own because of what the alternative looks like. An audit table that came
   * back empty would paint an empty grid, and an empty grid here is a statement - it says nobody has
   * ever changed a cost. When the real reason is that the table does not exist yet, that statement is
   * false, and it is false in the reassuring direction. So the screen finds out which it is and says.
   */
  probe(): Observable<ProductCostHistory[]> {
    return this.httpClient.get(this._endpoint + COST_HISTORY_ENTITY + '?limit=1').pipe(map((data) => {
      return <ProductCostHistory[]>data;
    }));
  }

  /**
   * Every change to one product's cost, newest first.
   *
   * Note for anyone reaching for this: the backend's `forProduct` runs a bare find with no
   * `relations`, so the rows come back with no product and no user attached however the controller's
   * join config is written. The grid on this screen therefore uses the crud list route with explicit
   * joins instead, which is also what gives it sorting, paging and search.
   *
   * @param productId the product whose history is wanted, not a history row id
   */
  getCostHistoryForProduct(productId: number): Observable<ProductCostHistory[]> {

    if (!productId || productId === -1) {
      throw new Error('You must supply a valid id in getCostHistoryForProduct');
    }

    return this.httpClient.get(this._endpoint + 'product/cost-history/' + productId).pipe(map((data) => {
      return <ProductCostHistory[]>data;
    }));
  }
}
